import catalogentries from './submodules/catalogentries';
import utils from '@/stores/utils';

const { getStorageKey } = utils;

const state = {

};

const mutations = {

};

const actions = {
    async init({ commit, dispatch, state }, params) {
        await dispatch('catalogentries/init', {
            filters: { limit: 10, ordering: "label" },
            url: params.url,
            fetch_stats: false,
        });
        await dispatch('catalogentries/fetchCatalogEntries');
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        catalogentries: catalogentries({
            storageKey: getStorageKey('browsecatalog', 'catalogentries'),
            fieldsToSave: ['limit', 'ordering']
        }),
    }
};
